<template>
  <div>
    <div style="height:60px" class="hidden-md-and-up"></div>
    <h2>REQUISITOS PARA EL REGISTRO</h2>
    <v-layout row wrap align-center>
      <v-flex x10 sm6 xs12>
        <Requisito :titulo="abogado.titulo" subheader="El abogado o abogada deberá:" :requisitos="abogado.requisitos" />
        <v-flex sm15>
          <Requisito subheader="" :requisitos="abogado.notas" />
        </v-flex>
      </v-flex>
      <v-flex x10 sm6 xs12>
        <v-flex sm15>
          <v-img :src="require('@/assets/registro_abogado.jpg')" ></v-img>
        </v-flex>
      </v-flex>
      <v-flex sm6>
        <v-img :src="require('@/assets/sociedad_civil.jpg')"></v-img>
      </v-flex>
      <v-flex sm6>
        <Requisito :requisitos="sociedad.requisitos" :titulo="sociedad.titulo" subheader="Requisitos" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Requisito from "@/components/Registro/Requisito";
export default {
  components: {
    Requisito
  },
  data() {
    return {
      abogado: {
        titulo: "Nuevo Abogado",
        requisitos: [
          {
            icon: "fingerprint",
            iconClass: "lime white--text",
            title: "1.	Tener habilitado su registro de Ciudadanía Digital, obtenido mediante los medios proporcionados por AGETIC.",
            subtitle:
              "<li>Sino cuentas con este registro, presiona aquí para registrarte <a href='https://www.gob.bo/ciudadania' target='_blank' class='blue--text' >www.gob.bo/ciudadania</a> </li><li>AGETIC te brinda los pasos para registrarte como Ciudadano Digital: <a href='https://www.youtube.com/watch?v=f51EyLfXBy0&t=38s' target='_blank'  >presiona aquí</a></li>",
          },
                    {
            icon: "language",
            iconClass: "blue white--text",
            title: "2. Ingresar al Sistema de Registro de la Abogacía (SRA)",
            subtitle:
              "Presiona aqui para ingresar <a href='https://sra.justicia.gob.bo' target='_blank' class='blue--text'>sra.justicia.gob.bo</a> ; acto seguido selecciona la opción <b>“Registro de Abogado”</b>",
          },
          {
            icon: "format_list_numbered",
            iconClass: "indigo white--text left",
            title: "3. Llenar el formulario de registro, para esto debe contar con:",
            subtitle:
              "<ul><li>Ingresar una Fotografía actualizada a <u><b>colores en fondo blanco</b>,  clara, de frente y sin lentes o sombrero</u>, tamaño 3x3, en formato JPG, no mayor a 1 MB.</li><li>Ingresar fotografía de su firma (bolígrafo de color azul ) estampada en un papel o fondo blanco, tamaño 3x6, en formato JPG, no mayor a 1MB.</li><li>En un solo documento tener escaneado su Cédula de Identidad, Título Profesional original a color (anverso y reverso) y el NIT (opcional) todo en formato PDF.</li></ul>"
          },
       
          {
            icon: "thumb_up",
            iconClass: "pink white--text rigth",
            title: "Aprobar la solicitud de registro a través de Ciudadanía Digital.",
            subtitle: null
          },
          {
            icon: "monetization_on",
            iconClass: "green wite--text",
            title: "Elegir la modalidad de pago, Código de Pago de Trámites (CPT) vinculado sólo al Banco Unión S.A. o QR vinculado a cualquier Banco.",
            subtitle: null
          },
          
        ],

        notas: [
          {
            icon: "warning",
            iconClass: "yellow black--text",
            title: "¡Importante!",
            subtitle: "El recojo de la credencial es personal o con Poder Notarial Específico.",
          }
        ]
      },
      sociedad: {
        titulo: "Sociedades Civiles",
        requisitos: [
          {
            icon: "fingerprint",
            iconClass: "lime white--text",
            title: "1.	Tener habilitado su registro de Ciudadanía Digital, obtenido mediante los medios proporcionados por AGETIC.",
            subtitle:
              "<li>Sino cuentas con este registro, presiona aquí para registrarte <a href='https://www.gob.bo/ciudadania' class='blue--text'target='_blank' >www.gob.bo/ciudadania</a></li><li>AGETIC te brinda los pasos para registrarte como Ciudadano Digital: <a href='https://www.youtube.com/watch?v=f51EyLfXBy0&t=38s' target='_blank' >presiona aquí</a></li>",
          },
          {
            icon: "language",
            iconClass: "blue white--text",
            title: "2. Ingresar al Sistema de Registro de la Abogacía (SRA)",
            subtitle:
              "Presiona aquí para ingresar <a href='https://sra.justicia.gob.bo' target='_blank' class='blue--text'>sra.justicia.gob.bo</a> ; acto seguido selecciona la opción <b>“Sociedades Civiles”</b>",
          },
          {
            icon: "format_list_numbered",
            iconClass: "indigo white--text",
            title: "Llena el formulario de registro, para esto debe contar con:",
            subtitle:
              "<ul><li>Acta o escritura de constitución que describa la estructura interna en formato PDF.</li><li>Reglamento y procedimientos internos en formato PDF.</li><li>Documento que acredite la designación del representante legal en formato PDF.</li></ul>"
          },
          {
            icon: "thumb_up",
            iconClass: "pink white--text",
            title: "Aprobar la solicitud de registro a través de Ciudadanía Digital.",
            subtitle: null
          },
          {
            icon: "monetization_on",
            iconClass: "green wite--text",
            title: "Elegir la modalidad de pago, Código de Pago de Trámites (CPT) vinculado sólo al Banco Unión S.A. o QR vinculado a cualquier Banco.",
            subtitle: null
          }
        ]
      }
    };
  },
  mounted: function () {
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Registro/Registro.vue